import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Menu from "./Menu.jsx";
import { gsap } from "../../gsap/gsap.min.js";
import { SplitText } from "../../gsap/SplitText.min.js";
import { ScrollTrigger } from "../../gsap/ScrollTrigger.min.js";

gsap.registerPlugin(SplitText, ScrollTrigger);

const Header = ({ openAboutFromMenu }) => {
	const [isMenuOpen, setIsMenuOpen] = useState(false);
	const buttonRef = useRef(null);
	const headerRef = useRef(null);

	let location = useLocation()

	useEffect(() => {
		const h = document.querySelector("header");
		if (location.pathname == '/' || location.pathname.match(/^home/)) {
			h.classList.add("header-home");
		} else {
			h.classList.remove("header-home");
		}
	}, [location]);


	const toggleMenu = () => {
		setIsMenuOpen(!isMenuOpen);
	};

	useEffect(() => {
		const split = new SplitText(buttonRef.current, { type: "chars" });
		gsap.from(split.chars, {
			duration: 0.5,
			opacity: 0,
			y: 10,
			stagger: 0.05,
			ease: "power2.out"
		});


		ScrollTrigger.create({
			trigger: headerRef.current,
			start: "top top",
			end: "bottom-=50 0",
			toggleClass: { targets: headerRef.current, className: "header-negative" },
			markers: false,
		});


		const mainLogo = document.querySelector(".main-logo");
		mainLogo.addEventListener("click", () => {
			gsap.to(window, { duration: 1, scrollTo: 0 });
			setIsMenuOpen(false);
		});

	}, [isMenuOpen]);

	return (
		<>
			<header className="py-2" ref={headerRef}>
				<div className="container-lg">
					<div className="row justify-content-between aling-items-center py-3">
						<Link to='/' className="main-logo col-8 d-flex aling-items-center justify-content-start hover-cursor">
							<img src="/Content/img/logo-epoca-black.svg" alt="Logo" className="object-fit-contain h-100 w-100" />
						</Link>
						<div className="menu-trg col-4 d-flex aling-items-center justify-content-end">
							<button className="hover-cursor noclick-from-anim-div fw-bold fs-5" onClick={toggleMenu} ref={buttonRef}>
								{isMenuOpen ? 'Close' : 'Open'}
							</button>
						</div>
					</div>
				</div>
			</header>
			<Menu isOpen={isMenuOpen} onMenuClose={() => setIsMenuOpen(false)} />
		</>
	);
};

export default Header;
